import React from 'react';
import { Trans } from '@lingui/macro';
import { Text } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

export const styledWrapper = css({
    fontSize: 'md',
    color: 'text.inverted',
    lineHeight: 'md',
    marginTop: '2xl',
    marginBottom: 0,
});

const OneCreditOneSample = () => (
    <Text className={styledWrapper}>
        <Trans>1 CREDIT = 1 ROYALTY-FREE SAMPLE</Trans>
    </Text>
);

export default OneCreditOneSample;
